import { EPromptOptimizationJobStatus } from '@/types/schema';

export const COMPLETED_STATUSES = [
  EPromptOptimizationJobStatus.SUCCESSFUL,
  EPromptOptimizationJobStatus.FAILED,
];
